import SCheckbox from "./components/field/Checkbox";
import SCheckboxSelect from "./components/field/CheckboxSelect";
import SDatetime from "./components/field/Datetime";
import SFile from "./components/field/File";
import SRadio from "./components/field/Radio";
import SSelect from "./components/field/Select";
import SText from "./components/field/Text";

const SFieldComponent = {
  install: (Vue) => {
    Vue.component("SCheckbox", SCheckbox);
    Vue.component("SCheckboxSelect", SCheckboxSelect);
    Vue.component("SDatetime", SDatetime);
    Vue.component("SCheckbox", SCheckbox);
    Vue.component("SFile", SFile);
    Vue.component("SRadio", SRadio);
    Vue.component("SSelect", SSelect);
    Vue.component("SText", SText);
  },
};

import { createField, updateDirty } from "./field/index";
import Vue from "vue";
import "./i18n-fallback";
import { DatetimePicker, Picker, Popup, Uploader } from "vant";
import { Cascader, Checkbox, DatePicker, Radio, Select } from "ant-design-vue";
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Uploader);

Vue.use(DatePicker);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Cascader);

import SkCheckbox from "./components/new-fields/sk-checkbox.vue";
import SkCheckboxSelect from "./components/new-fields/sk-checkbox-select.vue";
import SkDatePicker from "./components/new-fields/sk-date-picker.vue";
import SkFile from "./components/new-fields/sk-file.vue";
import SkImg from "./components/new-fields/sk-img.vue";
import SkRadio from "./components/new-fields/sk-radio.vue";
import SkRadioImg from "./components/new-fields/sk-radio-img.vue";
import SkCheckboxImg from "./components/new-fields/sk-checkbox-img.vue";
import SkSelect from "./components/new-fields/sk-select.vue";
import SkInput from "./components/new-fields/sk-input.vue";
import SkTextarea from "./components/new-fields/sk-textarea.vue";
import SkLine from "./components/new-fields/sk-line.vue";
import SkDesc from "./components/new-fields/sk-desc.vue";
import SkPolicy from "./components/new-fields/sk-policy.vue";
import SkCheckboxWap from "./components/new-fields/sk-checkbox-wap.vue";
import SkCheckboxSelectWap from "./components/new-fields/sk-checkbox-select-wap.vue";
import SkDatePickerWap from "./components/new-fields/sk-date-picker-wap.vue";
import SkFileWap from "./components/new-fields/sk-file-wap.vue";
import SkImgWap from "./components/new-fields/sk-img-wap.vue";
import SkRadioWap from "./components/new-fields/sk-radio-wap.vue";
import SkRadioImgWap from "./components/new-fields/sk-radio-img-wap.vue";
import SkCheckboxImgWap from "./components/new-fields/sk-checkbox-img-wap.vue";
import SkSelectWap from "./components/new-fields/sk-select-wap.vue";
import SkInputWap from "./components/new-fields/sk-input-wap.vue";
import SkTextareaWap from "./components/new-fields/sk-textarea-wap.vue";
import SkLineWap from "./components/new-fields/sk-line-wap.vue";
import SkDescWap from "./components/new-fields/sk-desc-wap.vue";
import SkPolicyWap from "./components/new-fields/sk-policy-wap.vue";

const SkFieldsComponents = {
  install: (Vue) => {
    Vue.component("SkCheckbox", SkCheckbox);
    Vue.component("SkCheckboxSelect", SkCheckboxSelect);
    Vue.component("SkDatePicker", SkDatePicker);
    Vue.component("SkCheckbox", SkCheckbox);
    Vue.component("SkRadioImg", SkRadioImg);
    Vue.component("SkCheckboxImg", SkCheckboxImg);
    Vue.component("SkFile", SkFile);
    Vue.component("SkImg", SkImg);
    Vue.component("SkRadio", SkRadio);
    Vue.component("SkSelect", SkSelect);
    Vue.component("SkInput", SkInput);
    Vue.component("SkTextarea", SkTextarea);
    Vue.component("SkLine", SkLine);
    Vue.component("SkDesc", SkDesc);
    Vue.component("SkPolicy", SkPolicy);
    Vue.component("SkCheckboxWap", SkCheckboxWap);
    Vue.component("SkCheckboxSelectWap", SkCheckboxSelectWap);
    Vue.component("SkDatePickerWap", SkDatePickerWap);
    Vue.component("SkCheckboxWap", SkCheckboxWap);
    Vue.component("SkRadioImgWap", SkRadioImgWap);
    Vue.component("SkCheckboxImgWap", SkCheckboxImgWap);
    Vue.component("SkFileWap", SkFileWap);
    Vue.component("SkImgWap", SkImgWap);
    Vue.component("SkRadioWap", SkRadioWap);
    Vue.component("SkSelectWap", SkSelectWap);
    Vue.component("SkInputWap", SkInputWap);
    Vue.component("SkTextareaWap", SkTextareaWap);
    Vue.component("SkLineWap", SkLineWap);
    Vue.component("SkDescWap", SkDescWap);
    Vue.component("SkPolicyWap", SkPolicyWap);
  },
};
export { SFieldComponent, SkFieldsComponents, createField, updateDirty };
